window.theme = window.theme || {};

window.theme.sizes = {
  mobile: 550,
  small: 767,
  large: 1023,
  widescreen: 1279,
};

window.theme.keyboardKeys = {
  TAB: 9,
  ENTER: 13,
  ESCAPE: 27,
  SPACE: 32,
  LEFTARROW: 37,
  RIGHTARROW: 39,
};

window.theme.dimensions = {
  headerScrolled: 60,
};

window.theme.loadedSPR = false;

window.theme.focusable = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
